<template lang="pug">
#ExpectationModule.expectation-module(:style="{'--delay-time':`${delay}s`}")
  .xs-12.xs-f-xxlarge.md-f-xxgrande.max-at-tweak.cw-color-11.text-center.kapra-neue.upper.mb-100m {{ title }}
  .wrap
    .video-wrap.xs-12.md-6
      video(:src="video.url" autoplay="true" muted="true" loop playsinline preload="auto" :title="video.alt_text")
    .items-wrap.xs-12.md-6.md-mt-200m
      .item.xs-pl-200m.md-200m(v-for="(item,index) in items" :class="{active: index == current}" @click="clickItem(index)" @mouseover="onHoverItem(index)" @mouseleave="onLeaveItem(index)")
        .bar
        .bar-fill
        span.number
          span.xs-f-small.bold {{ index+1 }}
        span.cw-color-11.xs-f-large.md-f-xmedium.max-at-tweak.bold {{ item.title }}
        .content-wrap
          p.text-color-3.xs-f-small.max-at-tweak.mt-100m.mb-100m(v-html="item.text")
          mr-btn(v-if="!hideCta" xsmall round no-right-padding no-uppercase tag="a" :href="item.cta.url" @click.prevent="clickHandler(item.cta.url)") {{ item.cta.text }}
            template(#appendContent="")
              .custom-circle.cw-color-11.ml-100m
                mr-icon(name="arrow-right")
    
</template>
<script>
  import { mapState } from 'vuex';
  import MrBtn from '@components/MrBtn';

  export default {
    name: "ExpectationModule",

    components: {
      MrBtn
    },

    props: {
      title: {
        type: String,
        default: ""
      },
      video: {
        type: Object,
        default: () => ({})
      },
      items: {
        type: Array,
        default: () => ([])
      },
      delay: {
        type: Number,
        default: 10
      },
      eventPrefix: {
        type: String,
        default: ""
      },
      hideCta: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        current: null,
        intervalId: null,
        hover: null,
      };
    },

    computed: {
      ...mapState('global', ['windowData']),

      breakpoint() {
        return this.windowData.breakpoint;
      },

      isMobile() {
        return this.breakpoint == "mobile";
      },

    },

    mounted() {
      this.current = 0;
      const options = {
        rootMargin: "0px",
        threshold: 0.5,
      };

      if (!this.isMobile) {
        this.initInterval();
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.initInterval();
          } else {
            this.clearInterval();
          }
        });

      }, options);

      observer.observe(document.getElementById("ExpectationModule"));
    },

    destroyed() {
      this.clearInterval();
    },

    methods: {
      clickItem(index) {
        if (index == this.current) {
          return;
        }
        this.current = index;
        if (!this.isMobile) {
          this.clearInterval();
        }
      },

      onHoverItem(index) {
        if (this.isMobile) {
          return;
        }
        this.hover = index;
        if (index == this.current) {
          this.clearInterval();
        }
      },

      onLeaveItem(index) {
        if (this.isMobile) {
          return;
        }
        if (index == this.hover && index == this.current && !this.intervalId) {
          this.initInterval();
        }

        this.hover = null;
      },

      initInterval() {
        this.intervalId = setInterval(this.intervalLoop, this.delay * 1000);
      },

      clearInterval() {
        this.intervalId = clearInterval(this.intervalId);
      },

      intervalLoop() {
        if (!this.hover) {
          this.current = (this.current + 1) % this.items.length;
        }
      },

      clickHandler(url) {
        let eventName = 'Location-specific LP Expectation module - CTA clicked';
        if (this.eventPrefix) {
          eventName = `${this.eventPrefix} - CTA clicked`;
        }
        this.trackMREventAndRedirect(eventName, url);
      }
    }

  };
</script>
<style lang="stylus" scoped>
.expectation-module
  display flex
  flex-direction column
  align-items center
  padding 5em 2em
  letter-spacing -0.01em
  
  .wrap
    width 100%
    max-width 1400px
    display flex
    gap 70px  
    justify-content center
    @media mq-tablet-less
      align-items center

    @media mq-tablet-less
      flex-direction column-reverse
      gap 30px
    
    .video-wrap
      border-radius 56px
      overflow hidden
      //max-width 300px
      video
        border-radius 56px
        width 100%
        object-fit contain
        
    .items-wrap
      max-width 300px
      display flex
      flex-direction column
      gap 1em
      @media mq-tablet-less
        max-width unset
      .item
        position relative
        transition 0.8s
        display flex
        flex-direction column
        .number
          display flex
          justify-content center
          align-items center
          background-color cta-color-4
          color ui-color-1
          border-radius 13px
          width fit-content
          overflow hidden
          height 30px
          width 30px
          max-height 0vh
          transition 0.8s
          span
            margin 0.5em
        .content-wrap
          max-height 0vh
          transition 0.8s
          overflow hidden

          .mrbtn
            background-color cta-color-4
            .btn-content
              text-transform none !important
              padding 0.75em 0
            .append-content
              .custom-circle
                height 2.25em
                width 2.25em
                background-color white
                margin-right 4px
                border-radius 50%
                display flex
                justify-content center
                justify-items center
                svg
                  width 0.9em
        &.active
          margin 2em 0 2em
          &:first-child
            margin-top 0
          .number
            max-height 10vh
            margin-bottom 1em
            transition 1.6s
          .content-wrap
            transition 1.6s
            max-height 30vh
            transition-delay 0.8s

          .bar-fill
            height 100%
            transition var(--delay-time,10s)
            transition-timing-function linear        

        .bar
          position absolute
          left 0
          top 0
          width 6px
          border-radius 16px
          height 100%
          background-color ui-color-4

        .bar-fill
          position absolute
          left 0
          top 0
          width 6px
          border-radius 16px
          height 0
          background-color cta-color-4
          transition 0.8s
</style>